<template>
  <section>
    <el-dialog
      :title="isAddCusMode?'新增货源计划':'添加流向数据'"
      :visible.sync="showAdd"
      width="60%"
      class="eldialog"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <div>
        <el-form
          ref="addCustomergoodsRef"
          :rules="rules"
          label-position="left"
          label-width="80px"
          :model="formLabelAlign"
          class="myform"
        >
          <div style="text-align: left;line-height: 50px;">
            <div style="display:flex;" v-if="!isAddCusMode">
              <el-form-item  class="sp_add_left" label="货源" style="overflow:hidden" label-width="90px"  prop="customerGoodsNum" key="addflow">
                <SimplePanelSelection @setVal="setGoodsNum" :allData="goodsNumSelectList"
                                      modeName="货源" keyStr="id"  valStr="selectStr"
                                      ref="huoyuan" @selectDataList="selectCustomerGoodsNum"
                                      :addCallback="true"
                ></SimplePanelSelection>
              </el-form-item>
              <el-form-item class="sp_add_right">
                <div style="text-align: right;"><el-button type="primary"  @click="addTab(editableTabsValue)">添加流向详情</el-button></div>
              </el-form-item>
            </div>

            <el-form-item label="货源编号" style="overflow:hidden" label-width="70px" v-if="isAddCusMode" key="addgoods">
              <el-input  placeholder="选择二级客户后自动生成货源编号" v-model="formLabelAlign.customergoodsNum" style="width:65%;float: left "></el-input>
              <span style="width: 27%;margin-left: 13%"><el-button type="primary"  @click="addTab(editableTabsValue)">添加流向详情</el-button></span>
            </el-form-item>
          </div>
          <div v-if="!isAddCusMode">
            <div style="display:flex;">
              <el-form-item label="一级客户" class="sp_add_left" label-width="90px">
                <el-input disabled :value="formData.customerOnelevelName"></el-input>
              </el-form-item>
              <el-form-item label="二级客户" class="sp_add_right" label-width="110px">
                <el-input disabled :value="formData.customerSecondlevelName"></el-input>
              </el-form-item>
            </div>
            <div style="display:flex;">
              <el-form-item label="货种" class="sp_add_left" label-width="90px">
                <el-input disabled :value="formData.goodsTypeName"></el-input>
              </el-form-item>
              <el-form-item label="计划装船日期" class="sp_add_right" label-width="110px">
                <el-input disabled :value="formData.transportTime"></el-input>
              </el-form-item>
            </div>
            <div style="display:flex;">
              <el-form-item label="货物来源" label-width="90px" class="sp_add_left">
                <el-input disabled :value="formData.goodsSourceName"></el-input>
              </el-form-item>
              <el-form-item label="业务员" label-width="110px" class="sp_add_right">
                <el-input disabled :value="formData.findGoodsUserName"></el-input>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="航线" label-width="90px" class="sp_add_left">
                <el-input disabled :value="formData.sysShiplineName"></el-input>
              </el-form-item>
            </div>
          </div>
          <div v-if="isAddCusMode">
            <div style="display: flex;height: 40px;">
              <div style="width: 45%; display: inline-block;">
                <el-form-item label="一级客户" label-width="70px">
                  <PanelSelection @setVal="setoneKehu" :allData="onecustomerList"
                                  modeName="客户" dataKey="common_onekehu"   keyStr="id" valStr="fullName"
                                  addUrl="/tms/sysCustomerOnelevel/quickCustomerSave"
                                  ref="onekehups"></PanelSelection>
                </el-form-item>
              </div>
              <div style="margin-left: 10px;width: 50%; display: inline-block">
                <el-form-item label="二级客户" prop="customerSecondlevelId" label-width="110px">
                  <PanelSelection @setVal="setKehu" :allData="customerList"
                                  modeName="客户" dataKey="common_kehu"   keyStr="id" valStr="abbreviationName"
                                  addUrl="/tms/sysCustomerSecondlevel/quickCustomerSave"
                                  ref="kehups" ></PanelSelection>
                </el-form-item>
              </div>

            </div>
            <div style="display:flex;height: 40px;margin-top: 20px;">
              <div style="width: 45%; display: inline-block">
                <el-form-item label="货种" prop="goodsType" label-width="70px">
                  <SimplePanelSelection
                    @setVal="setLeixing" :allData="huowuTypelist"
                    modeName="货种" keyStr="code"  valStr="value"
                    addDictionaryKey="goods_type"
                    ref="huowuleixing"
                  ></SimplePanelSelection>
                </el-form-item>
              </div>
              <div style="margin-left: 10px;width: 50%; display: inline-block;">
                <el-form-item label="计划装船日期" prop="transportTime" label-width="110px">
                  <el-date-picker
                    style="width: 100%;"
                    v-model="formLabelAlign.transportTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </div>
            </div>
            <div style="display:flex;height: 40px;margin-top: 20px;margin-bottom: 5px;">
              <div style="width: 45%; display: inline-block">
                <el-form-item label="业务员" label-width="70px">
                  <PanelSelection @setVal="setYewuyuan" :allData="userList"
                                  modeName="业务员" dataKey="common_yewuyuan"   keyStr="id" valStr="name"
                                  ref="yewuyuan" ></PanelSelection>
                </el-form-item>
              </div>
              <div style="margin-left: 10px;width: 50%; display: inline-block;">
                <el-form-item label="计划回款日期" label-width="110px">
                  <el-date-picker
                    style="width: 100%;"
                    v-model="formLabelAlign.planReturnDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </div>
            </div>
            <div style="display:flex;height: 40px;margin-top: 20px;margin-bottom: 5px;">
              <div style="width: 45%; display: inline-block">
                <el-form-item label="单证员" label-width="70px">
                  <PanelSelection @setVal="setDanzheng" :allData="userList"
                                  modeName="业务员" dataKey="common_yewuyuan"   keyStr="id" valStr="name"
                                  ref="danzheng" ></PanelSelection>
                </el-form-item>
              </div>
            </div>
            <div style="display:flex;height: 40px;margin-top: 20px;margin-bottom: 5px;">
              <div style="width: 45%; display: inline-block">
                <el-form-item label="货源来源" style=" cursor:pointer;text-align: left;" label-width="70px">
                  <el-tag  :type="formLabelAlign.goodsSource==1?'danger':'info'" style="margin-right: 20px;" @click="selectGoodsSource(1)">平台货</el-tag>
                  <el-tag :type="formLabelAlign.goodsSource==2?'success':'info'" @click="selectGoodsSource(2)">市场货</el-tag>
                </el-form-item>
              </div>
              <div style="margin-left: 10px;width: 50%; display: inline-block;">
              </div>
            </div>
            <div>
              <el-form-item label="航线" label-width="70px" style=" cursor:pointer;text-align: left;margin-bottom: 15px;margin-top: 15px;">
                <el-tag
                  v-for="(item,index) in linelist"
                  :key="index"
                  :type="linelistselect==index?'warning':'info'"
                  style="margin-right: 20px;margin-top: 5px;"
                  @click="selectline(index)">
                  <p style="position: relative;top:-10px" v-if="item.port1 && item.port2 ">{{item.port1}}-{{item.port2}}</p>
                  <p style="position: relative;top:-10px" v-if="item.port1 === '' || item.port2 === ''">其他航线</p>
                </el-tag>
              </el-form-item>
            </div>
          </div>
          <el-tabs v-model="editableTabsValue" type="card" closable
                   @tab-click="clickTab"
                   @tab-remove="removeTab">
            <el-tab-pane
              v-for="(item, index) in formLabelAlign.editableTabs"
              :key="item.name"
              :label="item.title"
              :name="item.name"
            >
              <div style="display: flex;">

                <el-form-item label="流向单号" style="overflow:hidden" class="sp_add_left" :prop="`editableTabs.${index}.flowNum`" :rules="flowNum">
                  <el-input placeholder="点击生成流向单号" v-model="item.flowNum" style="width:60%;float: left "></el-input>
                  <span @click="generateflowNum" style=" width:39%;color: #1A67FF; cursor: pointer;text-overflow: ellipsis">生成流向单号</span>
                </el-form-item>
              </div>

              <!-- 海运费信息 -->
              <!-- <div class="yf_title">
                <div class="left_title">
                  海运费信息录入
                </div>
                <div class="right_title">
                  <span class="yf_sq_text">收起</span>
                  <img class="yf_title_img" src="../../assets/img/shangjt.png"/>
                </div>
              </div>
              <div class="hyf_line">
                <div class="hyf_line_item">

                </div>
                <div class="hyf_line_item">

                </div>
                <div class="hyf_line_item">

                </div>
                <div class="hyf_line_item">

                </div>
              </div> -->

              <div style="display: flex;">
                <el-form-item label="装载码头" class="sp_add_left">
                  <PanelSelection @setVal="setZhuangzai" :allData="wharfList"
                                  modeName="码头" dataKey="common_wharf"   keyStr="id" valStr="wharf"
                                  addUrl="/tms/sysWharf/saveWharf"
                                  ref="zhuangzai"
                  ></PanelSelection>
                </el-form-item>
                <!--                        <el-form-item label="卸载码头" class="sp_add_right">-->
                <!--                          <PanelSelection @setVal="setXiezai" :allData="wharfList"-->
                <!--                                          modeName="码头" dataKey="common_wharf"   keyStr="id"  valStr="wharf"-->
                <!--                                          addUrl="/tms/sysWharf/saveWharf"-->
                <!--                                          ref="xiezai"-->
                <!--                          ></PanelSelection>-->
                <!--                        </el-form-item>-->
                <el-form-item label="卸货码头" class="sp_add_right">
                  <PanelSelection @setVal="setMudi" :allData="wharfList"
                                  modeName="码头" dataKey="common_wharf"   keyStr="id" valStr="wharf"
                                  addUrl="/tms/sysWharf/saveWharf"
                                  ref="mudi" @openCom="setTabIndex"
                  ></PanelSelection>
                </el-form-item>
              </div>
              <div>
                <div style="display:flex;">
                  <el-form-item label="货物吨位" class="sp_add_left" :prop="`editableTabs.${index}.tonnage`" :rules="tonnage">
                    <el-input v-model="item.tonnage" placeholder="输入货物吨位" step="0.01">
                      <template slot="append">吨</template>
                    </el-input>
                  </el-form-item>
                  <el-form-item label="品名" class="sp_add_right">
                    <SimplePanelSelection
                      @setVal="setPinming" :allData="productlist"
                      modeName="品名" keyStr="id"  valStr="name"
                      ref="pinming" :onlyclick="true"
                    ></SimplePanelSelection>
                    <!--                                  <SimplePanelSelection-->
                    <!--                                    @setVal="setPinming" :allData="productlist"-->
                    <!--                                    modeName="品名" keyStr="id"  valStr="name"-->
                    <!--                                    addDictionaryKey="goods_type"-->
                    <!--                                    ref="pinming"-->
                    <!--                                  ></SimplePanelSelection>-->
                  </el-form-item>
                </div>
                <div style="display: flex;">
                  <el-form-item label="终到地" class="sp_add_left">
                    <el-input v-model="item.endLocal" placeholder="输入货物终到地">
                    </el-input>
                  </el-form-item>
                </div>
                <div style="display: flex;">
                  <el-form-item label="是否装船过磅" label-width="100px" class="sp_add_left" style="cursor:pointer;text-align: left;">
                    <el-tag  :type="item.isLoadPass==0?'success':'info'" style="margin-right: 20px;" @click="setIsLoad(0)">否</el-tag>
                    <el-tag :type="item.isLoadPass==1?'success':'info'" @click="setIsLoad(1)">是</el-tag>
                  </el-form-item>
                  <el-form-item label="预估磅差" class="sp_add_right" :prop="`editableTabs.${index}.estimatDiff`" :rules="estimatDiff">
                    <el-input v-model="item.estimatDiff" placeholder="输入预估磅差" :disabled="item.isLoadPass == 0">
                    </el-input>
                  </el-form-item>
                </div>


              </div>
            </el-tab-pane>
          </el-tabs>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitobj" v-if="isAddCusMode">确 定</el-button>
          <el-button type="primary" v-if="!isAddCusMode" @click="saveFlow">确 定</el-button>
            </span>
    </el-dialog>
    <AddShipLineEdit @addShipLineCallback="addShipLineCallback" ref="addshiplineEdit"></AddShipLineEdit>
  </section>
</template>

<script>
  import dayjs from 'dayjs'
  import AddShipLineEdit from "../../components/shipline/addshiplinenewEdit";
  import PanelSelection from '../common/panelSelection'
  import SimplePanelSelection from '../common/simplePanelSelection'
  import {getAllUser} from "../../api/user";
  import {getAllCusTomerCode} from "../../api/syscustomersecondlevel";
  import {getAllSysWharf} from "../../api/sysWharf";

  import {ERR_OK} from "../../jslib/config";
  import {getDictionaryList} from "../../api/sysdictionary";
  import {getSysShipLine, getSysShipLines} from "../../api/sysshipline";
  import {saveCustomerGoodsAndCost,getCustomerGoodsNumList} from "../../api/customerGoodsSource";
  import {getAllShipPort} from "../../api/shipPort";
  import {getProductName} from "../../api/sysgoodtypes";
  import {fmtDateTime, fmtDictionary} from "../../jslib/util";
  import {getShipLineSelect} from "../../api/shipline";
  import {getFlowNumList,updateMongoIdx,saveFlowToCustomerGoods} from "../../api/customergoodscost";

  export default {
    props:{
      linelistselectparam:Number
    },
    data() {
      var checkCustomerName = (rule, value, callback) => {
        console.log("这次的检查值是："+value)
        if(this.formLabelAlign.customerSecondlevelId==null
          ||this.formLabelAlign.customerSecondlevelId==''){
          return callback(new Error('请选择客户'));
        }else{
          callback();
        }
      };
      var checkGoodsType = (rule, value, callback) => {
        if(this.formLabelAlign.goodsType==null
          ||this.formLabelAlign.goodsType==''){
          return callback(new Error('请选择货种'));
        }else{
          callback();
        }
      };
      var cusGoodsNum = (rule, value, callback) => {
        if(this.formLabelAlign.customerGoodsSourceId==null
          ||this.formLabelAlign.customerGoodsSourceId==''){
          return callback(new Error('请选择货源编号'));
        }else{
          callback();
        }
      };
      var checkNumLength = (rule, value, callback) => {
        if(value.toString().split('.')[0].length >6){
          return callback(new Error('长度不得超过6位'));
        }else{
          callback();
        }
      };
      var checkPercent = (rule, value, callback) => {
        if(value != null && value != ''){
          var patt1 = new RegExp(/^(100|[1-9]?\d(\.\d\d?)?)%$/ );
          var result = patt1.test(value);
          if(!result){
            return callback('请输入百分数');
          }else{
            callback();
          }
        } else {
          callback();
        }
      };
      return {
        selectShip:null,
        formData:{
          customerSecondlevelName:null,
          customerOnelevelName:null,
          goodsTypeName:null,
          transportTime:null,
          goodsSourceName:null,
          findGoodsUserName:null,
          sysShiplineName:null,
        },
        goodsNumSelectList:[],
        shipLineSelectList:[],
        customerGoodsIdx:null,
        flowNumIdx:null,
        flowIndex:null,
        customerGoodsIndex:null,
        oneCode:null,
        secondCode:null,
        flowNumList:[],
        goodsNumList:[],
        editableTabsValue:"1",
        formLabelAlign:{
          customerGoodsSourceId:null,
          customergoodsNum:null,
          linelistselect:null,
          sysShiplineId:null,
          customerSecondlevelId:'',
          customerOnelevelId:'',
          goodsSource:null,
          transportTime:'',
          goodsType:'',
          editableTabs: [{
            title: '流向详情',
            name: '1',
            freightNo:'',
            freight:'',
            dailiNo:'',
            daili:'',
            dailiCompany:null,
            taxDaili:null,

            tonnage:'',
            endLocal:'',
            productName:'',
            planReturnDate:'',
            finalWharf:'',
            flowNum:'',
            costType:1,
            contractCompany:null,
            taxFreight:null,
            isLoadPass:0,
            estimatDiff:null,
          }],
        },
        tabIndex: 1,
        tabIndexValue:1,
        visibleAddyewu:false,
        linelistselect: null,
        linelist: [],
        ships:[],
        huowuTypelist:[],
        productlist:[],
        customerList:[],
        onecustomerList:[],
        wharfList:[],
        userList:[],
        portList:[],
        showAdd: false,
        isAddCusMode:false,
        tabIndexRecord:null,
        voyageNumberlist :[],
        hetongTypelist:[],
        dictionaryLists:{},
        rules: {
          customerGoodsNum:
            [
              {required: true,  validator: cusGoodsNum,  trigger: 'change'}
            ],
          customerSecondlevelId:
            [
              {required: true,  validator: checkCustomerName,  trigger: 'change'}
            ],
          goodsType:
            [
              {required: true,  validator: checkGoodsType, trigger: 'blur'}
            ],
          transportTime:
            [
              {required: true,  message: '请选择起运日期', trigger: 'blur'}
            ],
        },
        estimatDiff:
          [
            {required: false,  validator: checkPercent, trigger: 'blur'}
          ],
        tonnage:
          [
            {required: true, validator: checkNumLength, trigger: 'blur'},
            { type: 'number', message: '吨位必须为数字值',
              transform (value) {
                if(value==undefined){
                  return null
                }
                return Number(value)
              }
            }
          ],
        freightNo:
          [
            { type: 'number', message: '运价必须为数字值',
              transform (value) {
                if(value==undefined){
                  return null
                }
                return Number(value)
              }
            }
          ],
        flowNum:[
          {required: true,  message: '请输入航次号', trigger: 'blur'},
        ],
      }
    },
    created() {
      // console.log("添加货源计划--------created")
    },
    mounted() {
      // console.log("添加货源计划--------mounted")
    },
    methods: {
      getSlNum(key){
        if(key==20){
          return 0.01;
        }else if(key==30){
          return 0.06;
        }else if(key==40){
          return 0.09;
        }else if(key==50){
          return 0.13;
        }
        return null;
      },
      modBHS(){
        var bhs = this.formLabelAlign.editableTabs[this.tabIndex].freightNo
        if(!bhs){
          return
        }
        var sl = this.formLabelAlign.editableTabs[this.tabIndex].taxFreight


        var slNum = this.getSlNum(sl)

        if(slNum!=null){
          var tmp = bhs/(1-slNum);
          this.formLabelAlign.editableTabs[this.tabIndex].freight = tmp.toFixed(2)
        }
      },
      modHS(){
        // var bhs = this.formLabelAlign.editableTabs[this.tabIndex].freightNo
        var hs = this.formLabelAlign.editableTabs[this.tabIndex].freight
        var sl = this.formLabelAlign.editableTabs[this.tabIndex].taxFreight

        var slNum = this.getSlNum(sl)
        if(slNum!=null){
          var tmp = hs*(1-slNum)
          this.formLabelAlign.editableTabs[this.tabIndex].freightNo = tmp.toFixed(2)
        }
      },

      modBHSDL(){
        var bhs = this.formLabelAlign.editableTabs[this.tabIndex].dailiNo
        if(!bhs){
          return
        }
        var sl = this.formLabelAlign.editableTabs[this.tabIndex].taxDaili

        var slNum = this.getSlNum(sl)

        if(slNum!=null){
          var tmp = bhs/(1-slNum);
          this.formLabelAlign.editableTabs[this.tabIndex].daili = tmp.toFixed(2)
        }
      },
      modHSDL(){

        var hs = this.formLabelAlign.editableTabs[this.tabIndex].daili
        var sl = this.formLabelAlign.editableTabs[this.tabIndex].taxDaili

        var slNum = this.getSlNum(sl)

        if(slNum!=null){
          var tmp = hs*(1-slNum)
          this.formLabelAlign.editableTabs[this.tabIndex].dailiNo = tmp.toFixed(2)
        }

      },
      leixingaddtaxCCDl(id){
        if(this.formLabelAlign.editableTabs[this.tabIndex].dailiCompany == id){
          this.formLabelAlign.editableTabs[this.tabIndex].dailiCompany=null
        } else {
          this.formLabelAlign.editableTabs[this.tabIndex].dailiCompany = id
        }
      },
      leixingaddtaxCC(id){
        if(this.formLabelAlign.editableTabs[this.tabIndex].contractCompany == id){
          this.formLabelAlign.editableTabs[this.tabIndex].contractCompany=null
        } else {
          this.formLabelAlign.editableTabs[this.tabIndex].contractCompany = id
        }
      },
      leixingaddtaxFDL(id){
        if( this.formLabelAlign.editableTabs[this.tabIndex].taxDaili == id){
          this.formLabelAlign.editableTabs[this.tabIndex].taxDaili=null
        } else {
          this.formLabelAlign.editableTabs[this.tabIndex].taxDaili = id
        }
      },
      leixingaddtaxF(id){
        if( this.formLabelAlign.editableTabs[this.tabIndex].taxFreight == id){
          this.formLabelAlign.editableTabs[this.tabIndex].taxFreight=null
        } else {
          this.formLabelAlign.editableTabs[this.tabIndex].taxFreight = id
        }

      },
      addShipLineCallback(obj){
        console.log(obj);
      },
      addshiplineEdit(obj){
        this.$refs.addshiplineEdit.showAddDataView();
      },
      getCname(id){
        for (var i=0;i<this.customerList.length;i++){
          var t = this.customerList[i];
          if(t.id == id){
            return t.abbreviationName
          }
        }
      },
      getOneCname(id){
        for (var i=0;i<this.onecustomerList.length;i++){
          var t = this.onecustomerList[i];
          if(t.id == id){
            return t.fullName
          }
        }
      },
      getUserCname(id){
        for (var i=0;i<this.userList.length;i++){
          var t = this.userList[i];
          if(t.id == id){
            return t.name
          }
        }
      },
      getLineCname(id){
        for (var i=0;i<this.linelist.length;i++){
          var t = this.linelist[i];
          if(t.id == id){
            return t.lineName
          }
        }
      },
      setGoodsNum(obj){
        if(obj.id != null && obj.id != ''){
          this.formLabelAlign.customerGoodsSourceId = obj.id
          this.formData.customerSecondlevelName =this.getCname(obj.customerSecondlevelId)
          this.formData.customerOnelevelName =this.getOneCname(obj.customerOnelevelId)
          this.formData.goodsTypeName = this.goods_typeFmt(obj.goodsType)
          this.formData.transportTime = obj.transportTime.substring(0,10)
          this.formData.goodsSourceName = obj.goodsSource == '1'?'平台':'市场'
          this.formData.findGoodsUserName = this.getUserCname(obj.findGoodsUser)
          this.formData.sysShiplineName = this.getLineCname(obj.sysShiplineId)
          this.getproduct(obj.goodsType)
        }
        // this.$set(this.formData, 'customerSecondlevelName', this.getCname(obj.customerSecondlevelId))
      },
      setShipLine(obj) {
        this.formLabelAlign.editableTabs[this.tabIndex].shiplineId = obj.shipLineId
        this.formLabelAlign.editableTabs[this.tabIndex].shipObj = obj
        for(var i=0;i<this.formLabelAlign.editableTabs.length;i++){
          if(this.formLabelAlign.editableTabs[i].shipObj != null){
            this.selectShip = this.formLabelAlign.editableTabs[i].shipObj
            return
          }
        }
      },
      setIsLoad(item){
        this.formLabelAlign.editableTabs[this.tabIndex].isLoadPass = item
        if(item == 0){
          this.formLabelAlign.editableTabs[this.tabIndex].estimatDiff = null
        }
      },
      setTabIndex(){
        this.tabIndexRecord = this.tabIndex
        console.info("this.tabIndexRecord=",this.tabIndexRecord)
      },
      clickTab(tabobj){

        this.tabIndex = tabobj.index
        console.log("当前选中的this.tabIndex = "+this.tabIndex )
      },
      addTab(targetName) {
        let newTabName = ++this.tabIndexValue + '';
        // let time = new Date().getTime().toString().substring(new Date().getTime().toString().length-5)
        var len = this.formLabelAlign.editableTabs.length

        this.tabIndex = len;

        let title = "流向详情-"+ len
        this.formLabelAlign.editableTabs.push({
          title: title,
          name: newTabName,
          freightNo:'',
          freight:'',
          dailiNo:'',
          daili:'',
          dailiCompany:null,
          taxDaili:null,

          tonnage:'',
          endLocal:'',
          productName:'',
          planReturnDate:'',
          finalWharf:'',
          flowNum:'',
          contractCompany:null,
          taxFreight:null,
          isLoadPass:0,
          estimatDiff:null,
        });
        this.editableTabsValue = newTabName;
        console.info(this.formLabelAlign.editableTabs)
        console.log("当前选中的this.tabIndex = "+this.tabIndex )
        console.info(this.selectShip)
        if(this.selectShip != null){
          this.$nextTick(function () {
            this.$refs.chuanqi[this.tabIndex].clickTag(this.selectShip)
          })
        }
      },
      removeTab(targetName) {
        this.$confirm('此操作将删除该流向, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let tabs = this.formLabelAlign.editableTabs;
          let activeName = this.editableTabsValue;
          if (activeName === targetName) {
            tabs.forEach((tab, index) => {
              if (tab.name === targetName) {
                let nextTab = tabs[index + 1] || tabs[index - 1];
                if (nextTab) {
                  activeName = nextTab.name;
                }
              }
            });
          }

          this.editableTabsValue = activeName;

          this.formLabelAlign.editableTabs = tabs.filter(tab => tab.name !== targetName);
          for (var i = 0; i < this.formLabelAlign.editableTabs.length; i++) {
            var tmp = this.formLabelAlign.editableTabs[i];
            if (tmp.finalWharf == null || tmp.finalWharf == '') {
              if (i == 0) {
                tmp.title = "流向详情"
              } else {
                tmp.title = "流向详情-" + i
              }
            }
          }
          if (this.tabIndexRecord == parseInt(targetName) - 1) {
            this.tabIndexRecord = null
          } else if (this.tabIndexRecord > parseInt(targetName) - 1) {
            this.tabIndexRecord = this.tabIndexRecord - 1
          }
          this.tabIndex = this.tabIndex - 1
          console.info("this.tabIndexRecord=", this.tabIndexRecord)
          console.log("当前选中的this.tabIndex = " + this.tabIndex)
          for (var i = 0; i < this.formLabelAlign.editableTabs.length; i++) {
            if (this.formLabelAlign.editableTabs[i].shipObj != null) {
              this.selectShip = this.formLabelAlign.editableTabs[i].shipObj
              return
            }
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      selectline(idx){
        // console.log("选择了路线："+idx)
        this.linelistselect = idx
        this.formLabelAlign.sysShiplineId = this.linelist[idx].id
      },
      selectShipLine(inputStr){
        getShipLineSelect(inputStr).then(res =>{
          if (res!=undefined&&res.resultCode === ERR_OK) {
            this.shipLineSelectList = res.data
          }
        })
      },
      selectCustomerGoodsNum(inputStr){
        getCustomerGoodsNumList(inputStr).then(res =>{
          if (res!=undefined&&res.resultCode === ERR_OK) {
            this.goodsNumList = res.list
            this.goodsNumSelectList = res.selectList
          }
        })
      },
      initList(){
        this.selectShipLine()
        this.selectCustomerGoodsNum()
        getDictionaryList("bill_tax,contract_company").then(res=>{
          if (res!=undefined&&res.resultCode === ERR_OK) {
            this.hetongTypelist = res.map['contract_company']
            this.dictionaryLists = res.map
          }
        })

        getFlowNumList().then(res =>{
          if (res!=undefined&&res.resultCode === ERR_OK) {
            this.flowIndex = res.flowIndex
            this.customerGoodsIndex = res.customerGoodsIndex
            this.flowNumList = res.list
          }
        })

        if(this.linelist==null
          ||this.linelist.length<=0){
          getSysShipLine().then(res=>{
            if (res!=undefined&&res.resultCode === ERR_OK) {
              this.linelist = res.list
            }
          })
        }

        // if(this.ships==null
        //   ||this.ships.length<=0){
        //   getSysShipLines().then(res => {
        //     if (res != undefined && res.resultCode === ERR_OK) {
        //       this.ships = res.ships
        //     }
        //   })
        // }

        if(this.huowuTypelist==null
          ||this.huowuTypelist.length<=0){
          getDictionaryList("goods_type").then(res=>{
            if (res!=undefined&&res.resultCode === ERR_OK) {
              this.huowuTypelist = res.map['goods_type']
            }
          })
        }
        if(this.customerList==null
          ||this.customerList.length<=0||
          this.onecustomerList==null
          ||this.onecustomerList.length<=0){
          getAllCusTomerCode().then(res=>{
            if (res!=undefined&&res.resultCode === ERR_OK) {
              this.customerList = res.list
              this.onecustomerList = res.onelist
            }
          })
        }
        if(this.portList==null
          ||this.portList.length<=0){
          getAllShipPort().then(res=>{
            if (res!=undefined&&res.resultCode === ERR_OK) {
              this.portList = res.list
            }
          })
        }
        if(this.wharfList==null
          ||this.wharfList.length<=0){
          getAllSysWharf().then(res=>{
            if (res!=undefined&&res.resultCode === ERR_OK) {
              this.wharfList = res.list
            }
          })
        }
        if(this.userList==null||
          this.userList.length<=0
        ){
          getAllUser().then(res=>{
            if (res!=undefined&&res.resultCode === ERR_OK) {
              this.userList = res.list
            }
          })
        }
      },
      openAddFlowPanel(){
        this.initList();
        this.selectShip = null
        this.flowNumIdx = null
        this.editableTabsValue="1"
        this.tabIndex = 0
        this.tabIndexValue = 1
        this.linelistselect=this.linelistselectparam,
          this.formLabelAlign = {
            customerGoodsSourceId:null,
            customergoodsNum:null,
            sysShiplineId:null,
            customerSecondlevelId:'',
            goodsSource:null,
            transportTime:'',
            goodsType:'',
            editableTabs: [{
              title: '流向详情',
              name: '1',
              freightNo:'',

              freight:'',
              dailiNo:'',
              daili:'',
              dailiCompany:null,
              taxDaili:null,

              tonnage:'',
              endLocal: '',
              productName:'',
              planReturnDate:'',
              finalWharf:'',
              flowNum:'',
              contractCompany:null,
              taxFreight:null,
              isLoadPass:0,
              estimatDiff:null,
            }],
          }
        this.formLabelAlign.sysShiplineId = this.linelist[this.linelistselect].id
        // this.selectline(0);

        // this.$nextTick(function () {
        //   this.$refs.huoyuan.clean()
        //   // this.$refs.onekehups.clean()
        //   // this.$refs.kehups.clean()
        //   // this.$refs.huowuleixing.clean()
        //   // this.$refs.yewuyuan.clean()
        //   this.$refs.mudi[0].clean()
        //   this.$refs.zhuangzai[0].clean()
        //   // this.$refs.xiezai[0].clean()
        //   this.$refs.pinming[0].clean()
        //   this.$refs.chuanqi[0].clean()
        //   this.$refs['addCustomergoodsRef'].resetFields();
        // })
        this.showAdd = true;


      },
      openAddPanel(){
        this.initList();
        this.selectShip = null
        this.flowNumIdx = null
        this.editableTabsValue="1"
        this.tabIndex = 0
        this.tabIndexValue = 1
        this.linelistselect=this.linelistselectparam,
          this.formLabelAlign = {
            customerGoodsSourceId:null,
            customergoodsNum:null,
            sysShiplineId:null,
            customerSecondlevelId:'',
            goodsSource:null,
            transportTime:'',
            goodsType:'',
            editableTabs: [{
              title: '流向详情',
              name: '1',
              freightNo:'',

              freight:'',
              dailiNo:'',
              daili:'',
              dailiCompany:null,
              taxDaili:null,

              tonnage:'',
              endLocal: '',
              productName:'',
              planReturnDate:'',
              finalWharf:'',
              flowNum:'',
              contractCompany:null,
              taxFreight:null,
              isLoadPass:0,
              estimatDiff:null,
            }],
          }
        this.formLabelAlign.sysShiplineId = this.linelist[this.linelistselect].id
        // this.selectline(0);

        // this.$nextTick(function () {
        //     this.$refs.onekehups.clean()
        //     this.$refs.kehups.clean()
        //     this.$refs.huowuleixing.clean()
        //     this.$refs.yewuyuan.clean()
        //     this.$refs.mudi[0].clean()
        //     this.$refs.zhuangzai[0].clean()
        //     // this.$refs.xiezai[0].clean()
        //     this.$refs.pinming[0].clean()
        //   this.$refs.chuanqi[0].clean()
        //     this.$refs['addCustomergoodsRef'].resetFields();
        // })
        this.showAdd = true;
        this.isAddCusMode = true;

      },
      setLeixing(obj){
        console.log("设置了货物类型！")
        console.log(obj)
        this.$refs.pinming[this.tabIndex].clean()
        this.formLabelAlign.goodsType = obj.code
        this.$refs.addCustomergoodsRef.validateField("goodsType");
        this.getproduct(obj.code)
      },
      setPinming(obj){
        this.formLabelAlign.editableTabs[this.tabIndex].productName = obj.id
      },
      getproduct(goodsType){
        getProductName(goodsType).then(res =>{
          if (res!=undefined&&res.resultCode === ERR_OK) {
            this.productlist = res.list
            console.info(res.list)
          }
        })
      },
      setYewuyuan(obj){
        console.log("设置了业务员！")
        console.log(obj)
        this.formLabelAlign.findGoodsUser = obj.id
      },
      setDanzheng(obj){
        console.log("设置了业务员！")
        console.log(obj)
        this.formLabelAlign.danzhengUser = obj.id
      },
      generateflowNum(){
        if(this.formLabelAlign.editableTabs[this.tabIndex].flowNum == null || this.formLabelAlign.editableTabs[this.tabIndex].flowNum ==''){
          // var idx = null
          // if(this.flowNumList != null && this.flowNumList.length>0){
          //   idx = this.flowNumList[0].substr(this.flowNumList[0].length-4)
          // } else {
          //   idx = "0000"
          // }
          var date = dayjs().format('YYYYMM')
          if(this.flowNumIdx == null){
            var num = date+this.flowIndex
            this.formLabelAlign.editableTabs[this.tabIndex].flowNum = 'LX-'+(parseInt(num)+1).toString()
            this.flowNumIdx = parseInt(num)+1
          } else {
            this.formLabelAlign.editableTabs[this.tabIndex].flowNum = 'LX-'+(this.flowNumIdx+1).toString()
            this.flowNumIdx = this.flowNumIdx+1
          }
        }
      },
      setCustomerNo(){
        // var idx = null
        // if(this.goodsNumList != null && this.goodsNumList.length>0){
        //   idx = this.goodsNumList[0].substr(this.goodsNumList[0].length-4)
        // } else {
        //   idx = "0000"
        // }
        var date = dayjs().format('YYYYMM')
        var num = date+this.customerGoodsIndex
        if(this.secondCode == null || this.secondCode == ''){
          this.formLabelAlign.customergoodsNum  = 'HY-'+(parseInt(num)+1).toString()
        } else if((this.oneCode == null || this.oneCode == '') &&(this.secondCode != null && this.secondCode != '')){
          this.formLabelAlign.customergoodsNum = this.secondCode+'-'+(parseInt(num)+1).toString()
        } else if((this.oneCode != null && this.oneCode != '') &&(this.secondCode != null && this.secondCode != '')){
          this.formLabelAlign.customergoodsNum = this.oneCode+'-'+this.secondCode+'-'+(parseInt(num)+1).toString()
        }
        this.customerGoodsIdx = parseInt(num)+1
      },
      setKehu(obj){
        // console.log("设置了客户！")
        // console.log(obj)
        this.formLabelAlign.customerSecondlevelId = obj.id
        this.secondCode = obj.code
        var oneCode = '';
        if(this.formLabelAlign.customerOnelevelId != null && this.formLabelAlign.customerOnelevelId != ''){
          for(var i=0;i<this.onecustomerList.length;i++){
            var tmp = this.onecustomerList[i]
            if(this.formLabelAlign.customerOnelevelId == tmp.id){
              oneCode = tmp.code
            }
          }
        }

        // var that =this
        // var cishu = that.voyageNumberlist[0].toString().slice(6)
        // var date = fmtDateTime(new Date(),'yyyyMM')
        // var pp = date + cishu
        // that.addShipLineInfo.voyageNumber = Number(pp) + 1
        this.setCustomerNo()
        this.$refs.addCustomergoodsRef.validateField("customerSecondlevelId");
      },
      setoneKehu(obj){
        // console.log("设置了客户！")
        // console.log(obj)
        this.formLabelAlign.customerOnelevelId = obj.id
        this.oneCode = obj.code
        if(this.formLabelAlign.customerSecondlevelId != null && this.formLabelAlign.customerSecondlevelId != ''){
          this.setCustomerNo()
        }
      },
      setMudi(obj){
        console.log("设置了目的港！")
        console.log(obj)

        this.formLabelAlign.editableTabs[this.tabIndex].finalWharf = obj.id
        //同步装载历史港口到卸载组件
        // this.$refs.addCustomergoodsRef.validate();
        if(obj.wharf != null && obj.wharf != ''){
          this.formLabelAlign.editableTabs[this.tabIndexRecord].title = obj.wharf
        }
      },
      setZhuangzai(obj){//设置装载码头
        console.log("设置了装载码头！")
        console.log(obj)

        this.formLabelAlign.editableTabs[this.tabIndex].loadWharf = obj.id
        //同步装载历史港口到卸载组件
        // this.$refs.xiezai.recordlist = this.$refs.zhuangzai.recordlist

        // this.$refs.addCustomergoodsRef.validate();

      },
      setXiezai(obj){//设置卸载码头
        console.log("设置了卸载码头！")
        console.log(obj)

        this.formLabelAlign.editableTabs[this.tabIndex].unloadWharf = obj.id
        //同步卸载历史港口到装载组件
        this.$refs.zhuangzai.recordlist = this.$refs.xiezai.recordlist
      },
      saveFlow(){
        if(this.formLabelAlign.editableTabs.length == 1){
          var tmp = this.formLabelAlign.editableTabs[0].flowNum
          for(var j = 0; j < this.flowNumList.length; j++){
            var tmp2 = this.flowNumList[j]
            if(tmp.substring(tmp.length -4) == tmp2.substring(tmp2.length -4)){
              this.$message({
                type: 'error',
                message: '流向单号重复'
              })
              return
            }
          }
        } else {
          for(var i = 0; i < this.formLabelAlign.editableTabs.length-1; i++){
            var tmp = this.formLabelAlign.editableTabs[i].flowNum
            var tmp2 = this.formLabelAlign.editableTabs[i+1].flowNum
            if(tmp.substring(tmp.length -4) == tmp2.substring(tmp2.length -4)){
              this.$message({
                type: 'error',
                message: '流向单号重复'
              })
              return
            }
            for(var j = 0; j < this.flowNumList.length; j++){
              var tmp3 = this.flowNumList[j]
              if(tmp.substring(tmp.length -4) == tmp3.substring(tmp3.length -4) || tmp2.substring(tmp2.length -4) == tmp3.substring(tmp3.length -4)){
                this.$message({
                  type: 'error',
                  message: '流向单号重复'
                })
                return
              }
            }
          }
        }
        this.$refs['addCustomergoodsRef'].validate((valid) => {
          if (valid) {
            this.toSaveFlow();
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      toSaveFlow(){
        console.log(this.formLabelAlign)
        this.formLabelAlign.costType = 1
        var goodStr = JSON.stringify(this.formLabelAlign)
        var goodsjson =  encodeURIComponent(goodStr)
        saveFlowToCustomerGoods(goodsjson).then(res =>{
          if (res!=undefined&&res.resultCode === ERR_OK) {
            this.updateMongoIdx()
            this.$message({
              type: 'success',
              message: '新增成功!'
            });
            this.$emit("saveSuccess",this.linelistselect)
          }
        })
      },
      submitobj(){//保存货源计划
        if(this.formLabelAlign.customergoodsNum != null){
          for (var i = 0; i < this.goodsNumList.length; i++){
            if (this.goodsNumList[i].substr(this.goodsNumList[i].length-4) === this.formLabelAlign.customergoodsNum.substr(this.formLabelAlign.customergoodsNum.length-4)){
              this.$message({
                type: 'error',
                message: '货源编号重复'
              })
              return
            }
          }
        }
        if(this.formLabelAlign.editableTabs.length == 1){
          var tmp = this.formLabelAlign.editableTabs[0].flowNum
          for(var j = 0; j < this.flowNumList.length; j++){
            var tmp2 = this.flowNumList[j]
            if(tmp.substring(tmp.length -4) == tmp2.substring(tmp2.length -4)){
              this.$message({
                type: 'error',
                message: '流向单号重复'
              })
              return
            }
          }
        } else {
          for(var i = 0; i < this.formLabelAlign.editableTabs.length-1; i++){
            var tmp = this.formLabelAlign.editableTabs[i].flowNum
            var tmp2 = this.formLabelAlign.editableTabs[i+1].flowNum
            if(tmp.substring(tmp.length -4) == tmp2.substring(tmp2.length -4)){
              this.$message({
                type: 'error',
                message: '流向单号重复'
              })
              return
            }
            for(var j = 0; j < this.flowNumList.length; j++){
              var tmp3 = this.flowNumList[j]
              if(tmp.substring(tmp.length -4) == tmp3.substring(tmp3.length -4) || tmp2.substring(tmp2.length -4) == tmp3.substring(tmp3.length -4)){
                this.$message({
                  type: 'error',
                  message: '流向单号重复'
                })
                return
              }
            }
          }
        }
        this.$refs['addCustomergoodsRef'].validate((valid) => {
          if (valid) {
            this.toSave();
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      toSave(){
        console.log(this.formLabelAlign)
        this.formLabelAlign.editableTabs.forEach(res =>{
          res.costType = 1
          res.shiplineId = "a"
        })
        var goodStr = JSON.stringify(this.formLabelAlign)
        var goodsjson =  encodeURIComponent(goodStr)
        saveCustomerGoodsAndCost(goodsjson).then(res=>{
          if (res!=undefined&&res.resultCode === ERR_OK) {
            this.updateMongoIdx()
            this.$message({
              type: 'success',
              message: '新增成功!'
            });
            this.$emit("saveSuccess",this.linelistselect)

          }
        })
        console.info(goodsjson)
      },
      updateMongoIdx(){
        var querydata = {
          flowIndex:this.flowNumIdx,
          customerGoodsIndex:this.customerGoodsIdx
        }
        updateMongoIdx(querydata).then(res =>{
          if (res!=undefined&&res.resultCode === ERR_OK) {
            this.handleClose()
          }
        })
      },
      handleClose(){
        this.showAdd = false;
        this.isAddCusMode = false;
        this.$nextTick(function () {
          if(!this.isAddCusMode){
            this.$refs.huoyuan.clean()
            // this.$refs.onekehups.clean()
            // this.$refs.kehups.clean()
            // this.$refs.huowuleixing.clean()
            // this.$refs.yewuyuan.clean()
            this.$refs.mudi[0].clean()
            this.$refs.zhuangzai[0].clean()
            // this.$refs.xiezai[0].clean()
            this.$refs.pinming[0].clean()
            this.$refs.chuanqi[0].clean()
            this.$refs['addCustomergoodsRef'].resetFields();
          } else {
            this.$nextTick(function () {
              this.$refs.onekehups.clean()
              this.$refs.kehups.clean()
              this.$refs.huowuleixing.clean()
              this.$refs.yewuyuan.clean()
              this.$refs.danzheng.clean()
              this.$refs.mudi[0].clean()
              this.$refs.zhuangzai[0].clean()
              // this.$refs.xiezai[0].clean()
              this.$refs.pinming[0].clean()
              this.$refs.chuanqi[0].clean()
              this.$refs['addCustomergoodsRef'].resetFields();
            })
          }
        })
      },
      selectGoodsSource(item){
        if( this.formLabelAlign.goodsSource == item){
          this.formLabelAlign.goodsSource=null
        } else {
          this.formLabelAlign.goodsSource =item
        }
        console.info(this.formLabelAlign)
      },
      goods_typeFmt(val){
        return fmtDictionary(val,this.huowuTypelist);
      },
    },
    components: {
      PanelSelection,
      SimplePanelSelection,
      AddShipLineEdit
    }
  }
</script>

<style scoped>
  .hyf_line{
    display: flex;
  }
  .hyf_line_item{
    width: 25%;
    text-align: left;
  }
  .yf_title{
    display: flex;
  }
  .left_title{
    width: 50%;
    text-align: left;
  }
  .right_title{
    width: 50%;
    text-align: right;
  }
  .yf_title_img{
    width: 25px;
  }

  .yf_sp_001{

  }
  .yf_sq_text{
    color: #5C95F2;
    margin-right: 5px;
  }

  .sp_add_left{
    width: 45%;
    margin-right: 5%;
  }
  .sp_add_right{
    width: 45%;
  }
  .kh_item1{
    margin: 5px 5px;
  }
  .eldialog >>> .el-dialog__body{
    padding: 0px 20px;
  }
  .myform >>> .el-form-item__label{
    text-align: center;
  }
  .el-input{
    width:100%;
  }
</style>
